var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 16C6.08333 16 5.72933 15.854 5.438 15.562C5.146 15.2707 5 14.9167 5 14.5V3H1.5C1.08333 3 0.729333 2.854 0.438 2.562C0.146 2.27067 0 1.91667 0 1.5C0 1.08333 0.146 0.729334 0.438 0.438C0.729333 0.146 1.08333 0 1.5 0H11.5C11.9167 0 12.2707 0.146 12.562 0.438C12.854 0.729334 13 1.08333 13 1.5C13 1.91667 12.854 2.27067 12.562 2.562C12.2707 2.854 11.9167 3 11.5 3H8V14.5C8 14.9167 7.854 15.2707 7.562 15.562C7.27067 15.854 6.91667 16 6.5 16ZM15.5 16C15.0833 16 14.7293 15.854 14.438 15.562C14.146 15.2707 14 14.9167 14 14.5V8H12.5C12.0833 8 11.7293 7.854 11.438 7.562C11.146 7.27067 11 6.91667 11 6.5C11 6.08333 11.146 5.72933 11.438 5.438C11.7293 5.146 12.0833 5 12.5 5H18.5C18.9167 5 19.2707 5.146 19.562 5.438C19.854 5.72933 20 6.08333 20 6.5C20 6.91667 19.854 7.27067 19.562 7.562C19.2707 7.854 18.9167 8 18.5 8H17V14.5C17 14.9167 16.854 15.2707 16.562 15.562C16.2707 15.854 15.9167 16 15.5 16Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.796a8294dc38be6f11c53c597b885332.svg";
export { ForwardRef as ReactComponent };